import UIComponent from "../ui/component";

export class ProgressVariant extends UIComponent {
    init() {
        this.variantId = this.element.dataset.variantId;
        this.timerInterval = null;
        this.estimate = null;
        this.initialEstimate = null;
        this.timerFinished = false;
        this.extendedProgressInterval = null;
        this.extendedProgressStartTime = null;
        this.extendedProgressValue = null;
        this.isInitialized = false;
        
        console.log('ProgressVariant init:', this.variantId, {
            hasProgressBar: !!this.progress_bar,
            hasTextTime: !!this.text_time,
            hasProgressContent: !!this.progress_content
        });
        
        // Используем setTimeout, чтобы дочерние компоненты успели инициализироваться
        setTimeout(() => {
            this.initializeElements();
        }, 0);
    }
    
    initializeElements() {
        // Проверяем наличие всех элементов
        console.log('ProgressVariant initializeElements:', this.variantId, {
            hasProgressBar: !!this.progress_bar,
            hasTextTime: !!this.text_time,
            hasProgressContent: !!this.progress_content,
            progressBarElement: this.progress_bar?.element,
            textTimeElement: this.text_time?.element
        });
        
        // Показываем прогресс контент сразу
        if (this.progress_content) {
            this.progress_content.removeClass('d-none');
            this.progress_content.show();
        } else {
            console.warn('ProgressVariant: progress_content not found', this.variantId);
        }
        
        // Устанавливаем начальную ширину прогресс-бара
        if (this.progress_bar && this.progress_bar.element) {
            this.progress_bar.element.style.width = "0%";
            // Обновляем текст внутри span
            const span = this.progress_bar.element.querySelector('span');
            if (span) {
                span.textContent = "0%";
            }
        } else {
            console.warn('ProgressVariant: progress_bar not found', this.variantId);
        }
        
        if (!this.text_time || !this.text_time.element) {
            console.warn('ProgressVariant: text_time not found', this.variantId);
        }
    }

    updateProgressBarText(text) {
        if (!this.progress_bar || !this.progress_bar.element) return;
        
        const span = this.progress_bar.element.querySelector('span');
        if (span) {
            span.textContent = text;
        } else {
            this.progress_bar.element.textContent = text;
        }
    }

    formatTime(seconds) {
        if (seconds <= 1) {
            return this.text_time?.end_of_time || "Завершаем...";
        }

        if (seconds > 1800) {
            return "> 30 min";
        }

        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (minutes > 0) {
            return `~ ${minutes}:${secs.toString().padStart(2, "0")}`;
        } else {
            return `~ 00:${secs.toString().padStart(2, "0")}`;
        }
    }

    updateProgress(estimate, passed) {
        if (!this.progress_bar || !this.text_time) {
            console.warn('ProgressVariant: progress_bar or text_time not found', this.variantId);
            return;
        }

        // Первая инициализация
        if (!this.isInitialized && estimate && passed !== undefined) {
            this.estimate = Math.round(estimate - passed);
            this.initialEstimate = estimate;
            this.isInitialized = true;

            console.log('ProgressVariant initialized:', {
                variantId: this.variantId,
                estimate: this.estimate,
                initialEstimate: this.initialEstimate,
                passed
            });

            // Проверяем, истекло ли прогнозируемое время
            const timeExpired = this.estimate <= 0;

            if (this.estimate > 0) {
                this.text_time.element.textContent = this.formatTime(this.estimate);
                this.startTimer();

                // 100% без завершенного процесса не показываем
                const progress = this.initialEstimate
                    ? Math.min(
                        ((this.initialEstimate - this.estimate) / this.initialEstimate) * 100,
                        97)
                    : 0;
                this.progress_bar.element.style.width = `${progress}%`;
                this.updateProgressBarText(`${Math.round(progress)}%`);
            } else {
                this.text_time.element.textContent = this.text_time.end_of_time;

                // Если время истекло, вычисляем расширенный прогресс
                if (timeExpired) {
                    const passedAfterExpiry = Math.abs(this.estimate); // секунды после истечения
                    const extendedProgress = 97 + Math.min((passedAfterExpiry / 600) * 2.9, 2.9);

                    // Убеждаемся, что прогресс не уменьшается при перезагрузке
                    const currentProgress = this.extendedProgressValue !== null
                        ? Math.max(this.extendedProgressValue, extendedProgress)
                        : extendedProgress;

                    this.extendedProgressValue = Math.min(currentProgress, 99.9);

                    this.progress_bar.element.style.width = `${this.extendedProgressValue}%`;
                    this.updateProgressBarText(`${this.extendedProgressValue.toFixed(1)}%`);

                    // Запускаем расширенный прогресс, если он еще не запущен
                    if (!this.extendedProgressInterval) {
                        this.extendedProgressStartTime = Date.now() - (passedAfterExpiry * 1000);
                        this.startExtendedProgress();
                    }
                } else {
                    // Если нет данных о времени, показываем 97%
                    this.progress_bar.element.style.width = "97%";
                    this.updateProgressBarText("97%");
                }
            }

            // Показываем прогресс контент
            if (this.progress_content) {
                this.progress_content.removeClass('d-none');
                this.progress_content.show();
            }
        } else if (this.isInitialized && estimate && passed !== undefined) {
            // Обновление на последующих вызовах - синхронизируем с сервером
            const serverEstimate = Math.round(estimate - passed);
            if (serverEstimate < this.estimate) {
                this.estimate = serverEstimate;
            }
        }
    }

    startTimer() {
        if (this.timerInterval || this.estimate <= 0 || this.timerFinished) {
            return;
        }

        this.timerInterval = setInterval(() => {
            if (this.estimate > 1) {
                this.text_time.element.textContent = this.formatTime(this.estimate);
                const progress = this.initialEstimate
                    ? Math.min(
                        ((this.initialEstimate - this.estimate) / this.initialEstimate) * 100,
                        97)
                    : 0;
                this.progress_bar.element.style.width = `${progress}%`;
                this.updateProgressBarText(`${Math.round(progress)}%`);
                this.estimate -= 1;
            } else {
                this.stopTimer();
                this.text_time.element.textContent = this.text_time.end_of_time;

                // Запускаем расширенный прогресс вместо фиксации на 97%
                this.extendedProgressStartTime = Date.now();
                this.extendedProgressValue = 97.0;
                this.progress_bar.element.style.width = "97.0%";
                this.updateProgressBarText("97.0%");
                this.startExtendedProgress();
            }
        }, 1000);
    }

    startExtendedProgress() {
        if (this.extendedProgressInterval) {
            return;
        }

        // Если extendedProgressStartTime уже установлен, вычисляем текущий прогресс на основе прошедшего времени
        if (this.extendedProgressStartTime) {
            const elapsedSeconds = Math.floor((Date.now() - this.extendedProgressStartTime) / 1000);
            const progressIncrease = Math.min((elapsedSeconds / 20) * 0.1, 2.9);
            const calculatedProgress = 97 + progressIncrease;

            // Используем максимальное значение между текущим и вычисленным, чтобы не уменьшать прогресс
            if (this.extendedProgressValue === null || this.extendedProgressValue < calculatedProgress) {
                this.extendedProgressValue = Math.min(calculatedProgress, 99.9);
            }
        } else if (this.extendedProgressValue === null) {
            this.extendedProgressValue = 97.0;
        }

        // Обновляем отображение с текущим значением
        this.progress_bar.element.style.width = `${this.extendedProgressValue}%`;
        this.updateProgressBarText(`${this.extendedProgressValue.toFixed(1)}%`);

        // Устанавливаем интервал для увеличения прогресса каждые 20 секунд
        this.extendedProgressInterval = setInterval(() => {
            if (this.extendedProgressValue < 99.9) {
                this.extendedProgressValue = Math.min(this.extendedProgressValue + 0.1, 99.9);
                this.progress_bar.element.style.width = `${this.extendedProgressValue}%`;
                this.updateProgressBarText(`${this.extendedProgressValue.toFixed(1)}%`);
            } else {
                this.stopExtendedProgress();
            }
        }, 20000);
    }

    stopExtendedProgress() {
        if (this.extendedProgressInterval) {
            clearInterval(this.extendedProgressInterval);
            this.extendedProgressInterval = null;
        }
    }

    stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        this.timerFinished = true;
        this.stopExtendedProgress();
    }

    complete() {
        this.stopTimer();
        this.stopExtendedProgress();
        
        if (this.progress_bar?.element) {
            this.progress_bar.element.style.width = "100%";
            this.updateProgressBarText("100%");
        }
        
        if (this.text_time?.element) {
            this.text_time.element.textContent = "00:00";
        }

        // Скрываем весь компонент (progress_content + внешний контейнер с py-4)
        setTimeout(() => {
            this.hide();
        }, 500);
    }

    showError() {
        this.stopTimer();
        this.stopExtendedProgress();
        
        // Скрываем прогресс, показываем ошибку
        this.progress_content?.hide();
        if (this.error_content) {
            this.error_content.removeClass('d-none');
            this.error_content.show();
        }
    }

    destroy() {
        this.stopTimer();
        this.stopExtendedProgress();
        super.destroy();
    }
}
